const DelegatingMdcBlockGroup = require('../_DelegatingMdcBlockGroup');

const types = require('./types');

class WorkflowCriteriaElement extends DelegatingMdcBlockGroup {
    constructor(hNodeTypeGroup, categorySpec, color, subset = '') {
        super(hNodeTypeGroup, categorySpec, color, subset);
        super.types = types;
    }
    addCodeGeneratorCustom(code, blocklyBlock, hNodeType) {
        let parent = blocklyBlock.getSurroundParent();
        let parentChildren = parent.getDescendants();
        let sequence =
            parentChildren.findIndex(function (value) {
                return value.id === blocklyBlock.id;
            }) - 1; // subtract 1 because includes parent with getDescendants
        code.sequence = sequence;

        return super.addCodeGeneratorCustom(code, blocklyBlock, hNodeType);
    }
}

module.exports = WorkflowCriteriaElement;
